import { VIDEO_TYPE } from '../../utils/urlVideoUtils';
import NativePlayerManager from './native/native.player.manager';
import YoutubePlayerManager from './youtube/YoutubePlayerManager';

/**
 * to implement several types of players.
 *
 */
export default class PlayerFactory {
  /** @constructor */
  constructor(videoData, config) {
    this.videoData = videoData;
    this.config = config;
  }

  getType(type) {
    switch (type) {
      case VIDEO_TYPE.HTML:
        return new NativePlayerManager(this.videoData);
      case VIDEO_TYPE.YOUTUBE:
        return new YoutubePlayerManager(this.videoData, this.config);

      default:
        return null;
    }
  }
}
